export default{
    getSimple: (state) => (keys) => {
        let objectReturn = {}
        for(let key in keys){
            let param = [keys[key]][0]
            objectReturn[param] = localStorage.getItem(`${param}`)
            if(objectReturn[param] && objectReturn[param].indexOf('"type":"object"') > 0){
                objectReturn[param] = JSON.parse(objectReturn[param])
                delete objectReturn[param].type 
                objectReturn[param] = objectReturn[param].data
            }
            if(!objectReturn[keys[key]]){
                objectReturn[keys[key]] = state[param]
            }
        }
        return objectReturn
    },
    getObject: (state) => (keys) => {
        let objectReturn = JSON.parse(localStorage.getItem(keys))
        return objectReturn
    },
    getFeedback: (state) => {
        return state.feedback
    }
}